// PROTBYTE main site.
export const PROTBYTE_SITE = 'https://protbyte.com';
export const PROTBYTE_CONTACT = `${PROTBYTE_SITE}/contact`;
